import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function TourAlbum2019() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            本社見学2019年
          </Typography>
          <Box my={4}>
            <Paper>
              <Grid className="p-3" spacing={4} container direction="row" justify="left">
                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191227_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市白山台放課後等デイサービスみゅ～みゅ～のみなさん(2019/12/27)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold" justify="center">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191218_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市社会福祉協議会シニアいきいき講座のみなさん(2019/12/18)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191217_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          南部町立福地小学校５年生のみなさん(2019/12/17)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191210_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          洋野町立帯島小学校５年生のみなさん(2019/12/10)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191206_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          いちゐ俳句会のみなさん(2019/12/06)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191129_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立高館小学校５年生のみなさん(2019/11/29)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191128_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          仙台育英学園高校通信制課程ＩＬＣ青森１〜３年生のみなさん(2019/11/28)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191126_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          南部町立剣吉小学校５年生のみなさん(2019/11/26)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191121_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          七戸町立城南小学校５年生のみなさん(2019/11/21)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191114_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          久慈市立夏井小学校５年生のみなさん(2019/11/14)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191113_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立柏崎小学校５年生のみなさん(2019/11/13)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191113_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立柏崎小学校５年生のみなさん(2019/11/13)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191113_03.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立柏崎小学校５年生のみなさん(2019/11/13)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191112_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          協同組合八戸総合卸センター企業活性化委員会のみなさん(2019/11/12)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191101_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          十和田市立北園小学校５年生のみなさん(2019/11/01)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191101_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          十和田市立北園小学校５年生のみなさん(2019/11/01)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191101_03.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          十和田市立北園小学校５年生のみなさん(2019/11/01)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191029_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          江陽「心の旅人塾」のみなさん(2019/10/29)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191024_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          おいらせ町立下田小学校５年生のみなさん(2019/10/24)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img191018_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          階上町立大蛇小学校４、５年生のみなさん(2019/10/18)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190925_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          九戸村立長興寺小学校５年生のみなさん(2019/09/25)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190924_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立城下小学校２年生のみなさん(2019/09/24)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190919_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          二戸市立金田一小学校５年生のみなさん(2019/09/19)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190912_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          三戸町立三戸小学校５年生のみなさん（１）(2019/09/12)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190912_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          三戸町立三戸小学校５年生のみなさん（２）(2019/09/12)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190904_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          青森県立八戸東高校１、２年生のみなさん(2019/09/04)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190902_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          九戸村立山根小学校５年生のみなさん(2019/09/02)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190902_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          九戸村立戸田小学校５年生のみなさん(2019/09/02)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190730_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          湊高台三丁目子ども会のみなさん(2019/07/30)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190718_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          おいらせ町木崎自主防災会のみなさん(2019/07/18)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190705_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          新郷村立戸来小学校５年生のみなさん(2019/07/05)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190703_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          十和田市・上金崎ゆうゆうクラブのみなさん(2019/07/03)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190603_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立大久喜小学校６年生のみなさん(2019/06/03)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190603_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立金浜小学校５、６年生のみなさん(2019/06/03)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190603_03.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立種差小学校６年生のみなさん(2019/06/03)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190426_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          尻内げんきサロンのみなさん(2019/04/26)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190314_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          根城ヨガクラブのみなさん(2019/03/14)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190306_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          青森県立八戸商業高校２年生のみなさん(2019/03/06)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190306_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市・是川老人クラブ和（なごむ）会のみなさん(2019/03/06)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190215_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立白銀小学校５年生のみなさん(2019/02/15)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190208_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          青森県立八戸聾学校小学部５年生のみなさん(2019/02/08)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190204_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立下長小学校５年生のみなさん(2019/02/04)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190204_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立下長小学校５年生のみなさん(2019/02/04)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190131_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立南郷小学校５年生のみなさん(2019/01/31)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190125_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          階上町立道仏小学校５年生のみなさん(2019/01/25)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190125_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立高館小学校５年生のみなさん(2019/01/25)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2019/k_img190122_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          南部町立名久井小学校５年生のみなさん(2019/01/22)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Box>
      </div>
    </div>
  );
}

export default TourAlbum2019;
